import _ from "lodash";
export const getApiKeysField = () => {
  const initKeys = ["id", "name", "clientId", "clientInfo.name", "requestDeadDate",
    "needPayAmount"];
  const typeMapping = {
    "COMMON": {
      keyNames: ["appreciation", "good", "revenue", "other", "payable"]
    },
    "NATIONAL": {
      keyNames: ["national", "nationalSales", "other", "payable"]
    },
    "PAYMENT": {
      keyNames: [ "payment" ]
    }
  };
  let _arr = [];
  Object.keys(typeMapping).forEach(type => {
    typeMapping[type].keyNames.forEach(key => {
      _arr.push(
        `targetSourceList.${key}.detail.uuid`,
        `targetSourceList.${key}.detail.showName`,
      );
    });
  });
  return initKeys.concat(_.uniq(_arr));
};

